import React, { useMemo } from 'react'

import { BASE_URL, ICONS } from '../../constants'

import { useClosure } from '../hooks'

import IncidentDate from '../../incidents/components/IncidentDate'

import styles from './ClosureListItem.module.css'

const getIconFromReason = (reason) => {
  switch (reason) {
    case 'Construction':
      return 'RoadClosures_Construction.png'
    case 'Flood':
      return 'RoadClosures_Flood.png'
    case 'Washout':
      return 'RoadClosures_Washout.png'
    case 'Snow/Ice':
      return 'RoadClosures_Snow.png'
    case 'Debris':
      return 'RoadClosures_Debris.png'
    case 'Emergency':
      return 'RoadClosures_Emergency.png'
    case 'Other':
      return 'RoadClosures_Other.png'
    default:
      return 'question.png'
  }
}

const ClosureListItem = ({ closureId }) => {
  const [
    { closedDate, closedBy, agency, reason, roadSegments },
    { select },
  ] = useClosure(closureId)

  const label = useMemo(() => {
    const roadNames = []
    roadSegments.forEach((segment) => {
      if (!roadNames.includes(segment.name)) roadNames.push(segment.name)
    })
    return roadNames.join(', ')
  }, [roadSegments])

  return (
    <li className={styles.item} onClick={select}>
      <img
        className={styles.icon}
        alt={reason}
        src={BASE_URL + ICONS.DIR + getIconFromReason(reason)}
      />
      <div className={styles.title}>{label}</div>
      <IncidentDate style={styles.timestamp} date={closedDate}>
        Closed -{' '}
      </IncidentDate>
      <div>
        By {closedBy} ({agency})
      </div>
    </li>
  )
}
export default ClosureListItem
